export enum ApiRoutesProductUsageGuides {
  Guides = "admin/product-usage-guides",
  ResolvedForProduct = "admin/product-usage-guides/resolved",
  // POST goes to `<Guides>/:guideId/faq`; PATCH and DELETE address the item
  // directly, without the guide id.
  FaqItems = "admin/product-usage-guides/faq"
}
